import React from 'react'
import BaseComponent, {toasting} from "../pages/base/BaseComponent";
import {Button, Card, Table} from "@themesberg/react-bootstrap";
import label from "enqc-utilities/src/label/Label"
import PropTypes from "prop-types";
import {isResponseOk} from "enqc-utilities/src/utils/Utilities";
import Endpoint from "enqc-utilities/src/api/Endpoint";
import {handleTimeAgo} from "enqc-utilities/src/utils/Utilities";
import PaginationTable from "./PaginationTable";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faMinus} from "@fortawesome/free-solid-svg-icons";


class UserDeviceTable extends BaseComponent{

    constructor(props) {
        super(props);
        this.state = {
            user:this.props.user?this.props.user:{},
            userDevices:[],
            page:1,
            totalPage: 0,
            totalElement: 0,
            pageElement: 0,
            sortOption:{}
        }
    }
    componentWillReceiveProps(nextProps, nextContext) {
        let {user} = this.state
        let nextUser = nextProps.user?nextProps.user:{}
        if(user.id!==nextUser.id){
            this.setState({user:nextUser},() => {
                this.getUserDevices()
            })
        }
    }

    delete(userDeviceId){
        this.props.showProcessing()
        this.get(Endpoint.API.USER_DEVICE_DELETE+"/"+userDeviceId, null, null, res => {
            if(res.code===200){
                toasting.success(label.SuccessDeletingData)
                this.getUserDevices()
            }
            this.props.closeProcessing()
        }, true, true);

    }

    getUserDevices(){
        let {user, userDevices,page} = this.state
        this.get(Endpoint.API.USER_DEVICES, {params:{"userNames":user.username, page:page-1}}, null, (res)=>{
            if(isResponseOk(res)){
                userDevices = res.data
                let totalPage = res.totalPage
                let totalElement = res.totalElement
                let pageElement = res.pageElement
                this.setState({userDevices,totalPage, totalElement, pageElement})
            }
        }, true, false)
    }


    render() {
        let {user, userDevices, page, pageElement, totalPage, totalElement, sortOption} = this.state
        return (
            <div>
                <Card border="light" className="table-wrapper shadow-sm">
                    <Card.Header>
                        <h5>{label.UserDevices}</h5>
                    </Card.Header>
                    <Card.Body className="p-0">
                        {this.renderDesktopTable()}
                        {this.renderMobileList()}
                    </Card.Body>
                    <div className="p-2">
                        <PaginationTable
                            onSelect={(page) => {
                                this.setState({page},() => {
                                    this.getUserDevices()
                                })
                            }}
                            showingRow={userDevices.length}
                            currentPage={page}
                            pageCount={totalPage}
                            totalElement={totalElement}/>
                    </div>

                </Card>
                {super.render()}
            </div>
        );
    }
    renderDesktopTable(){
        let {user, userDevices, page, pageElement, totalPage, totalElement, sortOption} = this.state
        return (
            <Table className="align-items-center table-flush p-0 d-none d-md-table">
                <thead className="thead-light">
                <tr>
                    <th scope="col">#</th>
                    <th scope="col">{label.Email}</th>
                    <th scope="col">{label.User}</th>
                    <th scope="col">{label.Platform}</th>
                    <th scope="col">{label.IPAddress}</th>
                    <th scope="col">{label.DeviceId}</th>
                    <th scope="col">{label.Remove}</th>
                </tr>
                </thead>
                <tbody>
                {
                    userDevices.map((userDevice, index)=>{
                        return(
                            <tr key={index}>
                                <td>
                                    {((page - 1) * pageElement) + (++index)}
                                </td>
                                <th scope="row">{userDevice.user?userDevice.user.email:"-"}</th>
                                <th scope="row">{userDevice.user?userDevice.user.fullname:"-"}</th>
                                <th scope="row">{userDevice.platform}</th>
                                <th scope="row">{userDevice.ipAddress}</th>
                                <th scope="row">{userDevice.deviceId}</th>
                                <th scope="row">
                                    <Button
                                        size="sm"
                                        variant="danger"
                                        onClick={event => {
                                            this.delete(userDevice.id)
                                        }}>
                                        <FontAwesomeIcon icon={faMinus}/>
                                    </Button>
                                </th>
                            </tr>
                        )
                    })                                    }
                </tbody>
            </Table>
        )
    }
    renderMobileList(){
        let {user, userDevices, page, pageElement, totalPage, totalElement, sortOption} = this.state
        return (
            <Table className="table-responsive align-items-center table-flush p-0 d-table d-md-none">
                <thead className="thead-light">
                <tr>
                    <th scope="col" className="p-1 text-center" style={{width:'7%'}}>#</th>
                    <th scope="col" className="p-1">{label.Field}</th>
                    <th scope="col" className="p-1">{label.Information}</th>
                    <th scope="col" className="text-center">{label.Remove}</th>
                </tr>
                </thead>
                <tbody>
                {
                    userDevices.map((userDevice, index)=>{
                        return(
                            <React.Fragment>
                                <tr key={index}>
                                    <td className="ps-2 p-1 text-center fw-bold bg-light border-bottom border-success" rowSpan={4} style={{width:'7%'}}>
                                        {((page - 1) * pageElement) + (++index)}
                                    </td>
                                    <td className="ps-2 p-1">
                                        {label.Name}
                                    </td>
                                    <td className="p-1">
                                        {userDevice.user&&userDevice.user.firstname}
                                    </td>
                                    <th rowSpan={4} className="text-center border-bottom border-success">
                                        <Button
                                            size="sm"
                                            variant="danger"
                                            onClick={event => {
                                                this.delete(userDevice.id)
                                            }}>
                                            <FontAwesomeIcon size="sm" icon={faMinus}/>
                                        </Button>
                                    </th>
                                </tr>
                                <tr key={index}>
                                    <td className="ps-2 p-1">
                                        {label.Email}
                                    </td>
                                    <td className="ps-2 p-1">
                                        {userDevice.user&&userDevice.user.email}
                                    </td>
                                </tr>
                                <tr key={index}>
                                    <td className="ps-2 p-1">
                                        {label.IPAddress}
                                    </td>
                                    <td className="ps-2 p-1">
                                        {userDevice.ipAddress}
                                    </td>
                                </tr>
                                <tr key={index}>
                                    <td className="ps-2 p-1 border-bottom border-success">
                                        {label.Platform}
                                    </td>
                                    <td className="ps-2 p-1 border-bottom border-success">
                                        {userDevice.platform}
                                    </td>
                                </tr>
                            </React.Fragment>
                        )
                    })
                }
                </tbody>
            </Table>
        )
    }
}

UserDeviceTable.propTypes = {
    user : PropTypes.any,
}

export default UserDeviceTable